export class UrlChanged {
	static readonly type = '[navigation] Url changed';
	constructor(
		public payload: {
			matterId: string;
			url: string;
			data: any;
			queryParams: {};
		},
	) {}
}

export class OnVisibilityChanged {
	static readonly type = '[navigation] on visibility changed';
	constructor(public payload: { visibility: string }) {}
}
